<template>
  <div class="portalcx-enterprise-signup-page">
    <div class="d-flex flex-column justify-content-md-start justify-content-md-center align-items-center">

      <div class="portalcx-enterprise-signup-page--logo d-none d-md-block">
        <img src="@/assets/images/portalcx-logo.svg" alt="PortalCX Logo">
      </div>

      <div class="portalcx-enterprise-signup-page--content d-flex flex-column flex-md-row">
        <div class="portalcx-enterprise-signup-page--description d-flex flex-column align-items-center justify-content-center">
          <img src="@/assets/images/icon-portal-black.svg" alt="PortalCX Logo">
          <p>Welcome</p>
          <p>PortalCX Enterprise</p>
          <span class="tos-privacy d-none d-md-block">
            <a href="https://www.portalcx.com/terms-of-service" target="_blank">Terms of Service</a> | <a href="https://www.portalcx.com/privacy-policy" target="_blank">Privacy Policy</a>
          </span>
        </div>

        <div class="portalcx-enterprise-signup-page--form">
          <div class="account-information">
            <validation-observer ref="accountInfoForm" v-slot="{ passes }">
              <b-form @submit.prevent="passes(getStarted)" autocomplete="off">
                <div class="account-information-row">
                  <div class="account-information-item">
                    <validation-provider vid="firstName" v-slot="{ errors }" rules="required">
                      <FormInput
                        v-model="form.firstName"
                        label="First Name"
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </div>
                  <div class="account-information-item">
                    <validation-provider vid="lastName" v-slot="{ errors }" rules="required">
                      <FormInput
                        v-model="form.lastName"
                        label="Last Name"
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="account-information-item">
                  <validation-provider vid="email" v-slot="{ errors }" rules="required|email">
                    <FormInput
                      v-model="form.email"
                      label="Email Address"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </div>
                <div class="account-information-item">
                  <validation-provider vid="phone" v-slot="{ errors }" rules="required|validPhoneNumber">
                    <FormInput
                      v-model="form.phone"
                      label="Phone"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </div>
                <div class="account-information-item">
                  <validation-provider vid="companyName" v-slot="{ errors }" rules="required">
                    <FormInput
                      v-model="form.companyName"
                      label="Company"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </div>
                <div class="account-information-item">
                  <validation-provider vid="password" v-slot="{ errors }" rules="required|validAccountPassword">
                    <FormInput
                      v-model="form.password"
                      label="Password"
                      type="password"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </div>
                <b-button
                  type="submit"
                  variant="primary"
                  class="account-information-item submit-button"
                >
                  Get started
                </b-button>
              </b-form>
            </validation-observer>
          </div>

          <p class="already-have-account">
            Already have an account? <a href="https://admin.portalcx.com/sign-in" target="_blank">Sign in</a>
          </p>

          <span class="tos-privacy d-block d-md-none">
            <a href="https://www.portalcx.com/terms-of-service" target="_blank">Terms of Service</a> | <a href="https://www.portalcx.com/privacy-policy" target="_blank">Privacy Policy</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/apis'
import FormInput from '@/components/form-input.vue'

export default {
  name: "EnterpriseSignUpPage",
  components: {
    FormInput,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        companyName: '',
        password: '',
      },
    }
  },
  created() {
    document.title = 'PortalCX - Enterprise';
    this.$store.commit('account/setIsAccountCreated', false);
  },
  methods: {
    async getStarted() {
      try {
        const { firstName, lastName, password, companyName, phone, email } = this.form;
        const irclickid = this.$store.getters['app/getIrclickid'];
        const planName = 'Enterprise'
        const planAmount = 'NA'
        const planType = window.location.pathname.substring(1);
        await API.account.register({
          firstName,
          lastName,
          password,
          companyName,
          ContactPhone: phone,
          Email: email,
          irclickid,
          planName,
          planAmount,
          planType
        });

        setTimeout(() => {
          this.$store.commit('account/setIsAccountCreated', true);
          this.$router.push('/signup-success');
        }, 1000);
      } catch(e) {
        console.error(e)
      }
    },
  }
}
</script>


<style lang="scss">
.portalcx-enterprise-signup-page {
  background-image: url('../assets/images/portalcx-back1.png');
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: contain;
  > div {
    min-height: 100vh;
    background: linear-gradient(144.26deg, #FFFFFF 25.71%, rgba(255, 255, 255, 0.0001) 100%);
    padding: 0 12px;
    @media screen and (max-width: 767px) {
      background: none;
      padding: 0;
    }
  }

  &--logo {
    margin: 93px 0 30px;
  }

  &--content {
    width: 100%;
    max-width: 1000px;
    margin-bottom: 64px;
    border-radius: 25px;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);

    > div {
      width: 50%;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    @media screen and (max-width: 767px) {
      border-radius: 0;
      box-shadow: none;
      margin-bottom: 0;
    }
  }

  &--description {
    border-radius: 25px 0 0 25px;
    background-color: #113A6B;
    gap: 1rem;

    > p {
      margin: 0;
      color: #F4F4F4;

      &:nth-child(2) {
        font-size: 18px;
        line-height: 1;
      }

      &:nth-child(3) {
        font-size: 36px;
        font-weight: 700;
        line-height: 1;
      }
    }

    >img {
      margin-top: auto;
    }

    .tos-privacy {
      margin-top: auto;
      margin-bottom: 1rem;
      color: #F4F4F4;
      text-align: center;
      font-size: 14px;
      line-height: 22px;

      > a {
        color: #F4F4F4;
        text-decoration: none;
        cursor: pointer;
      }
    }

    @media screen and (max-width: 767px) {
      border-radius: 0;
      padding: 24px 0;
    }
  }

  &--form {
    border-radius: 0 25px 25px 0;
    background-color: white;
    padding: 36px 24px 24px;

    .account-information {
      &-row {
        display: flex;
        gap: 1rem;

        @media screen and (max-width: 767px) {
          display: block;
          gap: none;
        }
      }

      &-item {
        width: 100%;
        margin-bottom: 1rem;

        &.submit-button {
          height: 4rem;
          border-radius: 8px;
          font-size: 21px;
          font-weight: 700;
          color: #333;
          margin-bottom: 0;

          @media screen and (max-width: 767px) {
            font-size: 18px;
            height: 45px;
            box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    @media screen and (max-width: 767px) {
      border-radius: 0;
      padding: 20px 24px 12px;
    }

    .already-have-account {
      margin: 0;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: black;
      text-align: center;

      > a {
        font-weight: 400;
        color: #2784BF;
        text-decoration: none;
        cursor: pointer;
      }
    }

    .tos-privacy {
      font-size: 14px;
      line-height: 22px;
      color: #18181B;
      text-align: center;
      margin-top: 20px;

      > a {
        color: #18181B;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 1200px) {
    background-position: top right;
    background-size: cover;
  }

  @media screen and (max-width: 767px) {
    background-image: none;
  }
}
</style>